module.exports = __webpack_public_path__ + "files/f6c6deb92bb7b72c19a425a06d5f70d4.png";